"use client";

import React from "react";
import { SectionData } from "./types";
import { editableSectionComponents } from "./sections";
import { HomepageProvider } from "./context/HomepageContext";

interface HomepageViewerProps {
    sections?: SectionData[];
    defaultLogo?: string;
}

export default function HomepageViewer({ sections = [], defaultLogo }: HomepageViewerProps) {
    if (!sections || !Array.isArray(sections)) return null;

    return (
        <HomepageProvider initialStatus="published" canEdit={false}>
            <div className="flex-1 w-full flex flex-col">
                {sections
                    .filter((s) => s.isVisible !== false)
                    .map((section) => {
                        const Component = editableSectionComponents[section.type];
                        if (!Component) return null;
                        return (
                            <div key={section.id} id={section.type} className="w-full">
                                <Component
                                    content={section.content}
                                    defaultLogo={defaultLogo}
                                />
                            </div>
                        );
                    })}
            </div>
        </HomepageProvider>
    );
}
